import React from "react";
import { Fonts } from "../../design/Font";
import { Colors } from "../../design/Colors";
import u299 from '../../images/accounts/u299.png'


export default class ClaimTable extends React.Component{

    getStatusColor(status){
        switch(status){
            case 'Paid':
                return Colors.green
            case 'Pending':
                return Colors.light_blue
            case 'In Process':
                return Colors.orange
            case 'Denied':
                return Colors.red
            default:
                return Colors.black
        }
    }

    render(){
        const {reimburesements}=this.props
        
            return(
                <div>
                    <div style={{...styles.table_header}}>
                        <div style={{...styles.table_header_item, width:'10vw'}}><span style={{...Fonts.white_text}}>Document Title</span></div>
                        <div style={{...styles.table_header_item, width:'13vw'}}><span style={{...Fonts.white_text}}>Description</span></div>
                        <div style={{...styles.table_header_item, width:'9vw'}}><span style={{...Fonts.white_text}}>Reimbursement Method</span></div>
                        <div style={{...styles.table_header_item, width:'7vw'}}><span style={{...Fonts.white_text}}>Last Update</span></div>
                        <div style={{...styles.table_header_item, width:'7vw'}}><span style={{...Fonts.white_text}}>Status</span></div>
                        <div style={{...styles.table_header_item, width:'6vw'}}><span style={{...Fonts.white_text}}>Action</span></div>
                    </div>
                    {reimburesements.map(item=>(
                    <div style={{display:'flex',flexDirection:'column',alignItems:'center',}}>
                        <div style={{...styles.table_entry}}>
                            <div style={{...styles.table_entry_item, width:'8.7vw',}}><span style={{...Fonts.text, textOverflow: 'ellipsis',whiteSpace: 'nowrap',}}>{item.title}</span></div>
                            <div style={{...styles.table_entry_item, width:'11.4vw',}}><span style={{...Fonts.text,textOverflow: 'ellipsis',whiteSpace: 'wrap',overflow:'hidden',width:'92%'}}>{item.description}</span></div>
                            <div style={{...styles.table_entry_item, width:'7.9vw',}}><span style={{...Fonts.text,textOverflow: 'ellipsis',whiteSpace: 'nowrap',}}>{item.method}</span></div>
                            <div style={{...styles.table_entry_item, width:'6.2vw',}}><span style={{...Fonts.text,textOverflow: 'ellipsis',whiteSpace: 'nowrap',}}>{item.updated}</span></div>
                            <div style={{...styles.table_entry_item, width:'6.2vw',}}><span style={{...Fonts.text,color:this.getStatusColor(item.status),textOverflow: 'ellipsis',whiteSpace: 'nowrap',}}>{item.status}</span></div>
                            <div style={{...styles.table_entry_item, width:'5.3vw', justifyContent:'flex-end',paddingRight:'2vw'}}><img alt="u299" src={u299} /></div>
                        </div>
                        <div style={{backgroundColor:Colors.grey,height:2, width:'46vw'}}/>
                    </div>
                ))}
                </div>
            ) 
        
    }
}
const styles={
    table_header:{
        display:'flex',
        flexDirection:'row',
        justifyContent:'center'
    },
    table_header_item:{
        display:'flex',
        backgroundColor:Colors.blue,
        margin:1,
        height:'4vh',
        alignItems:'center',
        paddingLeft: '0.4vw',
        paddingRight: '0.4vw',
        boxSizing: 'border-box',
        overflow: 'hidden',           // Hide overflowed text
        textOverflow: 'ellipsis',whiteSpace: 'nowrap',
    },
    table_entry:{
        display:'flex',
        flexDirection:'row',
        justifyContent:'center', 
    },
    table_entry_item:{
        display:'flex',
        backgroundColor:Colors.white,
        margin:1, 
        alignItems:'center',
        boxSizing: 'border-box',
        paddingLeft: '0.4vw',
        paddingRight: '0.4vw', 
        overflow: 'hidden',           // Hide overflowed text
        textOverflow: 'ellipsis',     // Show ellipsis for overflowed text
        whiteSpace: 'nowrap',         // Prevent text wrapping
    },
}